export const DATA = 'data';
export const CONFIG = 'config';
export const MEASUREMENT = 'measurement';
export const DOMAIN = 'domain';
export const MOUNT = 'mount';
